import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import DoublePendul from "./DoublePendul.json";

const DoublePendulAnimation = () => {
  const lottieRef = useRef(null);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: lottieRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: DoublePendul,
    });

    return () => {
      anim.destroy();
    };
  }, []);

  return (
    <div className="pendulum-container"
      ref={lottieRef}
    />
  );
};

export default DoublePendulAnimation;
